import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import { WINDOW_TOKEN } from '../../../services/bootstrap.service';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { IconComponent } from '../../../components/icon/icon.component';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-toolbar-item-print',
  templateUrl: 'toolbar-item-print.component.html',
  imports: [
    IconComponent,
    TranslatePipe,
    IconButtonComponent,
    AsyncPipe,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarItemPrintComponent {
  @HostBinding('class.td-wb-toolbar-item__print') toolbarPrintClass: boolean = true;
  @Input() autoSizeOverride: boolean = true;
  @Input() tdWbIconButtonBackground: IconButtonBackground = 'grey';

  breakpointChanges: Observable<BreakpointState>;

  constructor(@Inject(WINDOW_TOKEN) private browserWindow: Window, private platform: Platform, private mediaQueryService: MediaQueryService) {
    if (this.autoSizeOverride) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  print(): void {
    if (this.platform.SAFARI) {
      try {
        this.browserWindow.document.execCommand('print', false, null);
      } catch (e: unknown) {
        // eslint-disable-next-line no-console
        console.log(e);
        this.browserWindow.print(); // Future-proofing, if SAFARI decides to follow the consensus.
      }
    } else {
      this.browserWindow.print();
    }
  }
}
